import { useContext, useEffect } from 'react';
import { ActionStyle } from '../../action/action-constants.js';
import { HeadingContext } from '../../heading/components/heading-context/heading-context.js';
function useGalleryActions(props) {
    const headingContext = useContext(HeadingContext);
    useEffect(() => {
        if (!headingContext || !props.selectable) {
            if (props.selectedCards.size > 0) {
                props.onUnselectAll();
            }
            return;
        }
        const actions = [
            {
                enabled: true,
                id: 'gallery-external-action-select-all',
                onChange: (event) => event.value ? props.onSelectAll() : props.onUnselectAll(),
                onClick: props.onSelectAll,
                style: ActionStyle.CHECKBOX,
                tabIndex: 0,
                text: 'tws.gallery.select-all',
            },
            {
                className: 'c-gallery__download',
                enabled: true,
                id: 'gallery-external-action-download',
                onClick: props.onDownload,
                style: ActionStyle.TEXT,
                tabIndex: 0,
                text: 'tws.gallery.download',
            },
            {
                className: 'c-gallery__delete',
                enabled: true,
                id: 'gallery-external-action-delete',
                onClick: props.onDelete,
                style: ActionStyle.TEXT,
                tabIndex: 0,
                text: 'tws.gallery.delete',
            },
        ];
        const actionsRemover = actions.map(action => headingContext.addOrUpdateAction(action));
        return () => {
            actionsRemover.forEach(fn => fn());
        };
    }, [props, headingContext]);
}
export { useGalleryActions, };
//# sourceMappingURL=use-gallery-actions.js.map